// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, takeLatest } from 'redux-saga/effects';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import {
    getShippingAddressData,
    GET_SHIPPING_ADDRESS_DATA,
    getShippingAddressDataSuccess,
} from './../../../store/orderCreation';

function* getShippingAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: GET_SHIPPING_ADDRESS_DATA,
            })
        );

        yield put(getShippingAddressDataSuccess(request.payload));

        yield put(
            actionStatusSuccess({
                actionName: GET_SHIPPING_ADDRESS_DATA,
            })
        );
    } catch (e) {
        yield yield put(
            actionStatusFailed({
                actionName: GET_SHIPPING_ADDRESS_DATA,
                error: e,
            })
        );
    }
}

export default [takeLatest(`${getShippingAddressData}`, getShippingAddress)];
